enum SMAccessValidationTypes {
  restricted_investing_cayman = "restricted_investing_cayman",
  restricted_investing_primary_market = "restricted_investing_primary_market",
  not_verified = "not_verified",
  not_certified = "not_certified",
  is_us_resident = "is_us_resident",
  has_no_2fa_enabled = "has_no_2fa_enabled",
  pitch_closed_time = "pitch_closed_time",
  has_active_sell_order = "has_active_sell_order",
  no_sellable_shares = "no_sellable_shares",
  has_active_buy_order = "has_active_buy_order",
  no_shares_for_sell = "no_shares_for_sell",
  aml_failed = "aml_failed",
  sell_restricted_by_admin = "sell_restricted_by_admin",
  buy_restricted_by_admin = "buy_restricted_by_admin",
  sell_restricted_by_pep_sanction = "sell_restricted_by_pep_sanction",
  buy_restricted_by_pep_sanction = "buy_restricted_by_pep_sanction",
  sell_restricted_by_user_statement = "sell_restricted_by_user_statement",
  buy_restricted_by_user_statement = "buy_restricted_by_user_statement",
  sell_restricted_by_risk_rating = "sell_restricted_by_risk_rating",
  buy_restricted_by_risk_rating = "buy_restricted_by_risk_rating",
  sell_restricted_by_tier = "sell_restricted_by_tier",
  buy_restricted_by_tier = "buy_restricted_by_tier",
  sell_restricted_by_country_uk = "sell_restricted_by_country_uk",
  buy_restricted_by_country_uk = "buy_restricted_by_country_uk",
  sell_restricted_by_2fa = "sell_restricted_by_2fa",
  buy_restricted_by_2fa = "buy_restricted_by_2fa",
}

export default SMAccessValidationTypes;
